import { useTranslation } from "react-i18next";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { envChangeType } from "../../../../plugins/utils";
import styles from "./style.module.scss";

const TotalArea = ({ data }) => {
  const { t } = useTranslation();

  const itemEnum = [
    { label: t("myTeam.total.member"), value: data?.count || 0 },
    {
      label: t("myTeam.total.commission"),
      value:
        t(`currency.symbol.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`) +
        " " +
        moneyFormat(data?.count_price || 0),
    },
  ];

  const renderItem = (item, index) => {
    return (
      <div key={index}>
        <div className={styles.label}>{item.label}</div>
        <div className={styles.value}>{item.value}</div>
      </div>
    );
  };

  return (
    <div className={styles.totalArea}>
      <div className={styles.container}>
        {itemEnum.map((item, index) => {
          return renderItem(item, index);
        })}
      </div>
    </div>
  );
};

export default TotalArea;
